import {
  CreateOrganizationDtoSchema,
  type CreateOrganizationDto,
} from "@mimber/schema"

/**
 * Form schema for mimber-organization app
 * Excludes ownerId since it will be set automatically on the backend
 */
export const createOrganizationSchema = CreateOrganizationDtoSchema.omit({
  ownerId: true,
})

/**
 * Form data type without ownerId
 */
export type CreateOrganizationData = Omit<CreateOrganizationDto, "ownerId">
